const companies = [
  {
    id: 5000,
    name: "abc사",
    location: "서울특별시 금천구 가산디지털1로 189",
  },
  {
    id: 5001,
    name: "a사",
    location: "서울특별시 금천구 가산디지털1로 189",
  },
  {
    id: 5002,
    name: "b사",
    location: "부산광역시 동래구 동래로 136번길 12",
  },
  {
    id: 5003,
    name: "c사",
    location: "서울특별시 노원구 동일로 184길 35",
  },
  {
    id: 5004,
    name: "d사",
    location: "서울특별시 중구 세종대로 110",
  },

  {
    id: 5005,
    name: "e사",
    location: "서울특별시 중구 세종대로 110",
  },
  {
    id: 5006,
    name: "f사",
    location: "서울특별시 중구 세종대로 110",
  },
  {
    id: 5007,
    name: "g사",
    location: "서울특별시 중구 세종대로 110",
  },
];

export default companies;
